import { render } from "./CreateExperiment.vue?vue&type=template&id=0945734d&scoped=true"
import script from "./CreateExperiment.vue?vue&type=script&lang=js"
export * from "./CreateExperiment.vue?vue&type=script&lang=js"

import "./CreateExperiment.vue?vue&type=style&index=0&id=0945734d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0945734d"]])

export default __exports__